import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  ISigCodeDto,
  ISigCodePagedResultDto,
  ISigCodeCreateUpdateRequest
} from '../interfaces/Kroll/isig-code-dto';

@Injectable({
  providedIn: 'root'
})
export class SigCodeService {
  private apiUrl = '';

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.apiUrl = baseUrl + 'api/Kroll/';
  }

  getSigCodes(
    page: number = 1,
    pageSize: number = 10,
    sigCode?: string,
    description?: string,
    includeDeleted: boolean = true
  ): Observable<ISigCodePagedResultDto> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('pageSize', pageSize.toString())
      .set('includeDeleted', includeDeleted.toString());
    if (sigCode != null && sigCode.trim() !== '')
      params = params.set('sigCode', sigCode.trim());
    if (description != null && description.trim() !== '')
      params = params.set('description', description.trim());
    return this.http.get<ISigCodePagedResultDto>(this.apiUrl + 'SigCodes', { params });
  }

  getSigCode(id: number): Observable<ISigCodeDto> {
    return this.http.get<ISigCodeDto>(this.apiUrl + 'SigCodes/' + id);
  }

  createSigCode(request: ISigCodeCreateUpdateRequest): Observable<ISigCodeDto> {
    return this.http.post<ISigCodeDto>(this.apiUrl + 'SigCodes', request);
  }

  updateSigCode(id: number, request: ISigCodeCreateUpdateRequest): Observable<ISigCodeDto> {
    return this.http.post<ISigCodeDto>(this.apiUrl + 'SigCodes/Update/' + id, request);
  }
}
